import React, { useState, useEffect } from "react";
import { 
    Form, Input, Button, Row, Col, notification, Select, Table,
    InputNumber,
    Radio, 
} from "antd";
import { PlusOutlined, InfoCircleOutlined } from '@ant-design/icons';
import {
    getTemplateVpn, deleteTemplateVpn, addTemplateVpn
} from "../../../axios/api.device"
import { getAllCertificates} from "../../../axios/api.certificate"

import { useTranslation } from "react-i18next";
import { setConstantValue } from "typescript";

const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentVpn = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [vpnType, setVpnType] = useState<string>("L2TP");
    const [idle, setIdle] = useState<number>(0);
    const [userAuth, setUserAuth] = useState<string>("Password");
    const [mAuth, setMAuth] = useState<string>("Password");
    const [dataList, setDataList] = useState<any[]>([]);
    const [dataForm] = Form.useForm();

    const { t } = useTranslation();

    var addClick = () => { setShowTable(2) }

    useEffect(() => { 
        getDataInfo();
        getAllCertificates({search:""}).then(res=>{
            setDataList(res)
        });
      }, [])

    const getDataInfo = () => {
        getTemplateVpn(templateId).then((res) => {
            if (res?.vpnType) {
                setShowTable(2);
                setVpnType(res.vpnType);
                var req: any = {};
                req.vpnType = res.vpnType;
                req.name = res.vpnName;
                req.userName = res.userName;
                req.remoteAddress = res.remoteAddress;
                req.disconnectOnIdle = res.disconnectOnIdle ? 1 : 0;
                req.disconnectOnIdleTimer = res.disconnectOnIdleTimer;
                req.certId = res.certId;
                setIdle(req.disconnectOnIdle);
                if(res.vpnType == "L2TP")
                {
                    req.sendTraffic = res.sendTraffic;
                    req.userAuth = res.authType;
                    setUserAuth(req.userAuth);
                    req.password = res.authPassword;
                    req.sharePassword = res.sharePassword;
                }
                else
                {
                    req.mAuth = res.authType;
                    setMAuth(req.mAuth);
                    req.mPassword = res.authPassword;
                    req.mSharePassword = res.sharePassword;
                    req.localIdentifier =  res.localIdentifier;
                }
                dataForm?.setFieldsValue(req);
            } else {
                setShowTable(1)
            }
        })
    }

    const addTemplateClick = () => {
        dataForm?.validateFields().then((res) => {
            console.log(res);
            var req: any = {};
            req.vpnType = res.vpnType;
            req.vpnName = res.name;
            req.userName = res.userName ?? "";
            req.remoteAddress = res.remoteAddress;
            req.disconnectOnIdle = res.disconnectOnIdle;
            req.disconnectOnIdleTimer = res.disconnectOnIdleTimer ?? 0;
            req.sendTraffic = res.sendTraffic;
            if(res.vpnType == "L2TP")
            {
                req.authType = res.userAuth;
                req.authPassword = res.password ?? "";
                req.sharePassword = res.sharePassword ?? "";
            }
            else
            {
                req.authType = res.mAuth;
                req.authPassword = res.mPassword ?? "";
                req.sharePassword = res.mSharePassword ?? "";
                req.localIdentifier =  res.localIdentifier;
                if(res.mAuth == "Cert")
                {
                    req.certId = res.certId;
                }
                else
                    req.certId = null;
            }
            console.log(req);
            addTemplateVpn(templateId, req).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                getDataInfo();
            })
        })
    }

    const deleteTemplateClick = () => {
        deleteTemplateVpn(templateId).then(() => {
            updateTemplate();
            notification.success({ message: t("成功") });
            dataForm.resetFields();
            getDataInfo();
        })
    }

    const options = dataList.map(d => <Select.Option key={d.id} value={d.id}>{d.name}</Select.Option>);
    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("VPN")}</Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <>
                        <Form
                            style={{ marginLeft:45, marginTop: 16,width: '60%' }}
                            layout="horizontal"
                            form={dataForm}
                            labelCol={{ span: 6 }}
                            initialValues={{ vpnType: "L2TP",disconnectOnIdle:0,userAuth:"Password",
                                sendTraffic:true,mAuth:"Password" }}
                        >
                            <span style={{fontSize:"16px",paddingLeft:"3px"}}>
                                {t("连接设置")}
                                <div className="dividerStyle" style={{margin:"3px",marginBottom:"15px"}}></div>
                            </span>
                            <Item label={t("连接类型")} name="vpnType" rules={[{ required: true }]}>
                                <Select onChange={(key: string) => { 
                                    setVpnType(key);
                                }}>
                                    <Select.Option value="L2TP">{t("L2TP")}</Select.Option>
                                    <Select.Option value="IPSec">IPSec (Cisco)</Select.Option>
                                </Select>
                            </Item>

                            <Item label={t("连接名称")} name="name" rules={[{ required: true }]}>
                                <Input />
                            </Item>

                            <Item label={t("服务器名称/IP地址")} name="remoteAddress" rules={[{ required: true }]}>
                                <Input />
                            </Item>

                            <Item label={t("账户")} name="userName" 
                                extra={<><InfoCircleOutlined /> {t("指定%username%获取分配到设备的用户名")}</>}
                            >
                                <Input />
                            </Item>

                            <Item label={t("连接空闲时断开")} name="disconnectOnIdle" rules={[{ required: true }]}>
                                <Select onChange={(key: number) => { 
                                    setIdle(key);
                                }}>
                                    <Select.Option value={0}>{t("从不")}</Select.Option>
                                    <Select.Option value={1}>{t("间隔后")}</Select.Option>
                                </Select>
                            </Item>
                            <Item 
                                label={t("指定空闲时间")} 
                                name="disconnectOnIdleTimer"
                                hidden={idle !== 1}
                                rules={ idle == 1 ? [{ required: true }]:[]}
                            >
                                <InputNumber addonAfter={t("分钟")} />
                            </Item> 
                            <span style={{fontSize:"16px",paddingLeft:"3px"}}>
                                {t("身份验证设置")}
                                <div className="dividerStyle" style={{margin:"3px",marginBottom:"15px"}}></div>
                            </span>
                            <Item label={t("用户验证")} name="userAuth" hidden={vpnType != "L2TP"} >
                                <Radio.Group onChange={(e: any)=>{ 
                                    setUserAuth(e.target.value);
                                    }
                                    }>
                                    <Radio value={"Password"}>{t("密码")}</Radio>
                                    <Radio value={"Rsa"}>{t("RSA SecurID")}</Radio>
                                </Radio.Group>
                            </Item> 
                            <Item label={t("密码")} name="password" hidden={vpnType != "L2TP" || userAuth !== "Password"}>
                                <Input.Password />
                            </Item>
                            <Item label={t("共享的密码")} name="sharePassword" hidden={vpnType != "L2TP"}>
                                <Input.Password />
                            </Item>
                            <Item label={t("发送所有流量")} name="sendTraffic" hidden={vpnType != "L2TP"}>
                                <Radio.Group>
                                    <Radio value={true}>{t("Yes")}</Radio>
                                    <Radio value={false}>{t("No")}</Radio>
                                </Radio.Group>
                            </Item>

                            <Item label={t("机器验证")} name="mAuth" hidden={vpnType != "IPSec"} >
                                <Radio.Group onChange={(e: any)=>{ 
                                    setMAuth(e.target.value) 
                                    }}>
                                    <Radio value={"Password"}>{t("共享的密码")}</Radio>
                                    <Radio value={"Cert"}>{t("证书")}</Radio>
                                </Radio.Group>
                            </Item> 
                            <Item label={t("密码")} name="mPassword" hidden={vpnType != "IPSec"}>
                                <Input.Password />
                            </Item>
                            <Item label={t("组名称")} name="localIdentifier" hidden={vpnType != "IPSec" || mAuth != "Password"}>
                                <Input />
                            </Item>
                            <Item label={t("共享的密码")} name="mSharePassword" rules={(vpnType=="IPSec" && mAuth == "Password") ? [{ required: true }]:[]}  hidden={vpnType != "IPSec" ||  mAuth !== "Password"}>
                                <Input.Password />
                            </Item>
                            <Item label={t("证书")} name="certId" rules={(vpnType=="IPSec" && mAuth == "Cert") ? [{ required: true }]:[]} hidden={vpnType != "IPSec" || mAuth != "Cert"}>
                                <Select 
                                    showSearch
                                    placeholder={t("请选择证书")}
                                >
                                    { options }
                                </Select>
                            </Item>
                        </Form>

                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
        </div>

    </>)
};